<nav class="lg:hidden fixed bottom-0 left-0 right-0 w-full bg-white border-t border-[#DDDDE3] z-50"
    style="padding-bottom: env(safe-area-inset-bottom);">
    <div
        class="flex justify-between items-start pt-[9px] pb-[19px] px-[12px] w-full max-w-[744px] mx-auto md:max-w-none">

        @for (item of items; track item.label) {

        <!-- Internal route -->
        @if (item.type === 'link-internal') {
        <a [routerLink]="item.route" routerLinkActive [routerLinkActiveOptions]="{ exact: item.exactMatch ?? false }"
            #rla="routerLinkActive"
            class="flex flex-col items-center justify-center p-2 rounded-[4px] w-[47px] relative">
            <div class="flex flex-col gap-[4px] items-center justify-center">
                <span class="relative flex h-[14px] w-[22px] items-center justify-center">
                    <span
                        aria-hidden="true"
                        [class.text-[#F5234B]]="rla.isActive" [class.text-[#1C2024]]="!rla.isActive"
                        class="block w-[12px] h-[12px] bg-current [-webkit-mask-repeat:no-repeat] [mask-repeat:no-repeat] [-webkit-mask-position:center] [mask-position:center] [-webkit-mask-size:contain] [mask-size:contain]"
                        [style.-webkit-mask-image]="'url(' + item.icon + ')'"
                        [style.mask-image]="'url(' + item.icon + ')'">
                    </span>
                    @if ((item.badgeCount?.() ?? 0) > 0) {
                    <span
                        class="absolute left-[12px] top-[-5px] flex h-[14px] min-w-[14px] items-center justify-center rounded-full bg-[#F5234B] px-[3px] font-inter text-[10px] font-bold leading-[14px] text-white">
                        {{ (item.badgeCount?.() ?? 0) > 99 ? '99+' : item.badgeCount?.() }}
                    </span>
                    }
                </span>
                <span [class.text-[#F5234B]]="rla.isActive" [class.text-[#1C2024]]="!rla.isActive"
                    class="font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px] whitespace-nowrap">
                    {{ item.label }}
                </span>
            </div>
            @if (rla.isActive) {
            <div class="absolute bottom-0 left-1/2 -translate-x-1/2 w-[6px] h-[6px] rounded-full bg-[#F5234B]"></div>
            }
        </a>
        }

        <!-- External link -->
        @if (item.type === 'link-external') {
        <a [href]="item.href" rel="noopener noreferrer"
            class="flex flex-col items-center justify-center p-2 rounded-[4px] relative">
            <div class="flex flex-col gap-[4px] items-center justify-center">
                <span class="relative flex h-[14px] w-[22px] items-center justify-center">
                    <img [src]="item.icon" [alt]="item.label" class="w-[12px] h-[12px] object-contain" />
                    @if ((item.badgeCount?.() ?? 0) > 0) {
                    <span
                        class="absolute left-[12px] top-[-5px] flex h-[14px] min-w-[14px] items-center justify-center rounded-full bg-[#F5234B] px-[3px] font-inter text-[10px] font-bold leading-[14px] text-white">
                        {{ (item.badgeCount?.() ?? 0) > 99 ? '99+' : item.badgeCount?.() }}
                    </span>
                    }
                </span>
                <span
                    class="font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px] whitespace-nowrap text-[#1C2024]">
                    {{ item.label }}
                </span>
            </div>
        </a>
        }

        <!-- Button (menú, notificaciones, etc.) -->
        @if (item.type === 'button') {
        <button type="button" (click)="item.action?.()"
            class="flex flex-col items-center justify-center p-2 rounded-[4px] relative bg-transparent border-0 cursor-pointer">
            <div class="flex flex-col gap-[4px] items-center justify-center">
                <img [src]="item.icon" [alt]="item.label" class="w-[12px] h-[12px] object-contain" />
                <span
                    class="font-inter text-[12px] font-semibold leading-[16px] tracking-[0.04px] whitespace-nowrap text-[#1C2024]">
                    {{ item.label }}
                </span>
            </div>
        </button>
        }

        }
    </div>
</nav>
